import { Bookmark, Menu, Search } from "lucide-react";
import type { ChangeEvent } from "react";
import styles from "./AppHeader.module.css";

interface AppHeaderProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  onMenuOpen: (trigger: HTMLButtonElement) => void;
  onShowSaved: () => void;
}

export function AppHeader({
  searchValue,
  onSearchChange,
  onMenuOpen,
  onShowSaved,
}: AppHeaderProps) {
  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    onSearchChange(event.currentTarget.value);
  };

  return (
    <header className={styles.header}>
      <button
        className={styles.iconButton}
        type="button"
        aria-label="Öppna meny"
        aria-haspopup="dialog"
        onClick={(event) => onMenuOpen(event.currentTarget)}
      >
        <Menu aria-hidden="true" />
      </button>

      <div className={styles.searchField}>
        <Search className={styles.searchIcon} aria-hidden="true" />
        <label className="visually-hidden" htmlFor="game-search">
          Sök bland alla spel
        </label>
        <input
          id="game-search"
          type="search"
          value={searchValue}
          placeholder="Sök bland alla spel"
          autoComplete="off"
          onChange={handleSearchChange}
        />
      </div>

      <button
        className={styles.iconButton}
        type="button"
        aria-label="Visa sparade spel"
        onClick={onShowSaved}
      >
        <Bookmark aria-hidden="true" />
      </button>
    </header>
  );
}
